export default class AdviceList {
    constructor() {
        
    }
}

new AdviceList();